import { AppRoutes } from '@shared/helpers';
import { PageNotFoundData } from '@shared/interfaces';

export const pageNotFoundDefaultData: PageNotFoundData = {
    content: 'pageNotFound.defaultContent',
    previousLink: AppRoutes.routes().DASHBOARD,
    previousPageTitle: 'appNav.dashboard',
};
